// Suppliers aren't all UK-based (e.g. stone imported from India), so a
// purchase order can be raised in a currency other than GBP. Shared by the
// list and create/edit pages so the symbol shown always matches the code.
export const CURRENCY_OPTIONS = ['GBP', 'EUR', 'USD', 'INR'];

const CURRENCY_SYMBOLS: Record<string, string> = {
  GBP: '£',
  EUR: '€',
  USD: '$',
  INR: '₹',
};

export function currencySymbol(code: string): string {
  return CURRENCY_SYMBOLS[code] || code + ' ';
}
